import { UserSettingsCopy, UserSettingsHeaderCopy } from 'ComponentLibrary/src/molecules/UserSettings/types'
import type { DropdownOption } from 'ComponentLibrary/src/piazza/forms'
import { NotificationSettingsTableCopy } from 'ComponentLibrary/src/widgets/NotificationSettingsTable/types'
import { TFunction } from 'i18next'
import { SUPPORTED_LOCALES, SupportedLocale } from 'ClientPortal/src/i18n/supportedLocales'

const PREFIX = 'settings.userSettingsPage'

export function getLocaleOptions(t: TFunction): DropdownOption<SupportedLocale>[] {
    return SUPPORTED_LOCALES.map((locale) => ({
        value: locale,
        label: t(`${PREFIX}.locales.${locale}`),
    }))
}

export function getUserSettingsHeaderCopy(t: TFunction): UserSettingsHeaderCopy {
    return {
        header: t(`${PREFIX}.profile.personalProfile`),
        logout: t(`${PREFIX}.profile.logout`),
        headerImageAlt: t(`${PREFIX}.profile.headerImageAlt`),
        userImageAlt: t(`${PREFIX}.profile.userImageAlt`),
        uploadImageAriaLabel: t(`${PREFIX}.profile.uploadImageAriaLabel`),
    }
}

export function getUserSettingsCopy(t: TFunction, tTerminology: TFunction, tValidation: TFunction): UserSettingsCopy {
    return {
        labels: {
            first_name: tTerminology('form.firstName'),
            last_name: tTerminology('form.lastName'),
            salutation: tTerminology('form.salutation'),
            job_title: tTerminology('form.jobTitle'),
            phone_number: tTerminology('form.phoneNumber'),
            team: tTerminology('form.team'),
            header: t(`${PREFIX}.profile.personalProfile`),
            email: tTerminology('form.email'),
            logout: t(`${PREFIX}.profile.logout`),
            certification: tTerminology('form.certification'),
            locale: tTerminology('form.locale'),
        },
        salutationOptions: [
            { label: tTerminology('salutations.none'), value: '-' },
            { label: tTerminology('salutations.mr'), value: 'Herr' },
            { label: tTerminology('salutations.ms'), value: 'Frau' },
            { label: tTerminology('salutations.mrDr'), value: 'Herr Dr.' },
            { label: tTerminology('salutations.msDr'), value: 'Frau Dr.' },
        ],
        teamSectionTitle: t(`${PREFIX}.profile.teamSectionTitle`),
        invalidPhoneNumberMessage: tValidation('invalidPhoneNumber'),
        teamRequiredMessage: tValidation('required'),
        discardChangesDialogTitle: tTerminology('confirmation.discardAllUnsavedChanges'),
        discardChangesConfirmLabel: tTerminology('confirmation.discard'),
        discardChangesCancelLabel: tTerminology('confirmation.cancel'),
        modal: {
            profileImageLabel: t(`${PREFIX}.modal.profileImage`),
            uploadImageLabel: t(`${PREFIX}.modal.uploadImage`),
            removeImageLabel: t(`${PREFIX}.modal.removeImage`),
            removeImageConfirmation: {
                title: t(`${PREFIX}.modal.removeImageConfirmation.title`),
                message: t(`${PREFIX}.modal.removeImageConfirmation.message`),
                cancelLabel: tTerminology('confirmation.cancel'),
            },
            rowLabels: {
                job_title: tTerminology('form.jobTitle'),
                phone_number: t(`${PREFIX}.modal.rowLabels.phoneNumber`),
                team: tTerminology('form.team'),
                email: t(`${PREFIX}.modal.rowLabels.email`),
                certification: tTerminology('form.certification'),
                locale: tTerminology('form.locale'),
            },
        },
    }
}

export function getNotificationSettingsTableCopy(t: TFunction): NotificationSettingsTableCopy {
    return {
        off: t('settings.notificationSettingsContent.notifications.table.off'),
        immediate: t('settings.notificationSettingsContent.notifications.table.immediate'),
        batch: t('settings.notificationSettingsContent.notifications.table.batch'),
        batchTooltip: t('settings.notificationSettingsContent.notifications.table.batchTooltip'),
    }
}
